import { OperationalTipoMoneda } from "./operationalTipoMoneda.model";

export class MontoCompra {

  static path = 'monto_compra/';

  monto: number;
  tipoMoneda: OperationalTipoMoneda = new OperationalTipoMoneda();

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/montoCompra.model.ts